import { MenuItem, Select } from '@mui/material';

/*
*   Выпадающий список с вариантами периода
*/

export enum PeriodSelectType {
    LastWeek = 'lastWeek',
    LastMonth = 'lastMonth',
    LastTwoMonth = 'lastTwoMonth',
}

type PeriodTypeSpec = {
    name: string,
    daysQuantity: number,
    code: string,
}

export const PeriodSelectTypeSpec: { [key in PeriodSelectType]: Omit<PeriodTypeSpec, 'code'> } = {
    [PeriodSelectType.LastWeek]: { name: 'Прошедшая неделя', daysQuantity: 7 },
    [PeriodSelectType.LastMonth]: { name: 'Прошедший месяц', daysQuantity: 30 },
    [PeriodSelectType.LastTwoMonth]: { name: 'Прошедшие 2 месяца', daysQuantity: 60 },
}

const PeriodTypeList: PeriodTypeSpec[] = Object.keys(PeriodSelectTypeSpec).map(code => ({
    ...PeriodSelectTypeSpec[code as keyof typeof PeriodSelectTypeSpec],
    code: code as PeriodSelectType,
}));

type PeriodSelectProps = {
    selectedPeriodType: PeriodSelectType,
    handleSelectedPeriodChange: (periodType: PeriodSelectType) => void,
}

export default function PeriodSelect({selectedPeriodType, handleSelectedPeriodChange}: PeriodSelectProps) {

    return (
        <Select
            sx={{width: '20%'}}
            size='small'
            defaultValue={PeriodSelectType.LastWeek}
            value={selectedPeriodType}
            onChange={(event) => handleSelectedPeriodChange(event.target.value as PeriodSelectType)}
        >
            {PeriodTypeList.map((el) =>
                <MenuItem
                    key={el.code}
                    value={el.code}
                >
                    {el.name}
                </MenuItem >,
            )}
        </Select>
    );
}
